import { Api } from "./api"

export class CompanyApi extends Api {
  constructor() {
    super('company', ['name', 'countryCode', 'logo', 'initialPlanIdSelection', 'companyType', 'dormantAccountStatus', 'email'])
  }
}
